import { blue, neutral } from "@flat-ui";
import { BarChartPro } from "@mui/x-charts-pro/BarChartPro";
import { AnalyticsChartProps } from "@components/analytics/in-house/constants/analytics-constants";
import { shouldRenderXTickLabel } from "@components/analytics/in-house/utils/analytics-utils";

/** Renders the bar variant for in-house analytics data. */
export function AnalyticsBarChart({
  dataset,
  xTickStep,
  yAxisLabel,
  seriesUnitLabel,
}: AnalyticsChartProps): JSX.Element {
  return (
    <>
      {/* eslint-disable @typescript-eslint/naming-convention -- MUI X chart API uses third-party prop names */}
      <BarChartPro
        height={360}
        margin={{ top: 32, right: 32, bottom: 70, left: 70 }}
        xAxis={[
          Object.assign(
            {
              scaleType: "band" as const,
              data: dataset.map((item) => item.label),
              tickLabelInterval: (_value: string, index: number) =>
                shouldRenderXTickLabel(index, dataset.length, xTickStep),
              disableLine: true,
              disableTicks: true,
              tickLabelStyle: {
                fontSize: 14,
                fill: neutral[600],
              },
            },
            { categoryGapRatio: 0.5 }
          ),
        ]}
        yAxis={[
          {
            min: 0,
            label: yAxisLabel,
            tickMinStep: 1,
            valueFormatter: (value) => `${Math.round(value)}`,
            disableLine: true,
            disableTicks: true,
            labelStyle: {
              fill: neutral[600],
            },
            tickLabelStyle: {
              fontSize: 14,
              fill: neutral[600],
              transform: "translate(10px, 2px)",
            },
          },
        ]}
        grid={{ horizontal: true, vertical: false }}
        sx={{
          "&, .MuiBarChart-root": {
            border: "none",
            outline: "none",
            boxShadow: "none",
            backgroundColor: "transparent",
          },
          ".MuiChartsAxis-root .MuiChartsAxis-tickLabel": {
            transform: "translateY(2px)",
          },
          ".MuiChartsAxis-line": {
            stroke: "transparent",
          },
          ".MuiChartsAxis-tick": {
            stroke: "transparent",
          },
          ".MuiChartsGrid-line": {
            stroke: neutral[300],
            strokeDasharray: "2 5",
          },
          ".MuiBarElement-root": {
            fill: blue[400],
            rx: 2,
            ry: 2,
          },
        }}
        series={[
          {
            data: dataset.map((item) => item.value),
            color: blue[400],
            label: undefined,
            stack: undefined,
            type: "bar",
            valueFormatter: (value) => `${value ?? 0} ${seriesUnitLabel}`,
            highlightScope: { highlight: "none", fade: "none" },
          },
        ]}
      />
      {/* eslint-enable @typescript-eslint/naming-convention */}
    </>
  );
}
